import Vue from 'vue'
import Router from 'vue-router'
// import Signature from '@/pages/Signature/Signature'
// import Exhibition from '@/pages/Exhibition/Exhibition'
// import Sign from '@/pages/Sign/Sign'
// import Login from '@/pages/Login/Login'
// import Getcode from '@/pages/Getcode/Getcode'
// import LoadingUrl from '@/pages/LoadingUrl/LoadingUrl'
// import queryPay from '@/pages/queryPay/queryPay'
// import Face from '@/pages/Face/Face'
//大同
// import vehicleDetail from '@/pages/vehicle/vehicleDetail'
// import payMent from '@/pages/vehicle/payMent'
// import scanPay from '@/pages/vehicle/scanPay'
// import vehicleTerms from '@/pages/vehicle/vehicleTerms'
// import vehiclePayStatus from '@/pages/vehicle/vehiclePayStatus'
// import Face from '@/pages/Face/index'

// import credentialsPolicy from '@/pages/InsurancePolicy/credentialsPolicy'
// import searchPolicy from '@/pages/InsurancePolicy/searchPolicy'

// import loadingPay from '@/pages/LoadingPay/LoadingPay'

Vue.use(Router)

export default new Router({

  routes: [
    // {
    //   path: '/',
    //   redirect: '/CFgongbao',
    //   component: () => import(/* webpackChunkName: "group-common"*/'@/pages/CFgongbao/gongbao'),
    //   meta:{
    //     title:'紫金保险'
    //   }
    // },
    // {
    //   path: '/',
    //   redirect: '/Login',
    //   component:() => import(/* webpackChunkName: "group-common" */'@/pages/Login/Login'),
    //   // component: Login,
    //   meta: {
    //     title: '登录'
    //   }
    // },

    // {
    //   path: '/',
    //   redirect: '/Sign',
    //   component:() => import(/* webpackChunkName: "group-common" */'@/pages/Sign/Sign'),
    //   meta: {
    //     title: '签名'
    //   }
    // },
    {
      path: '/Signature',
      name: 'Signature',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/Signature/Signature'),
      // component: Signature,
      meta: {
        title: '签名'
      }
    },
    {
      path: '/Exhibition',
      name: 'Exhibition',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/Exhibition/Exhibition'),
      // component: Exhibition,
      meta: {
        title: '签名'
      }
    },
    {
      path: '/Sign',
      name: 'Sign',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/Sign/Sign'),
      // component: Sign,
      meta: {
        title: '签名'
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/Login/Login'),
      // component: Login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/Getcode',
      name: 'Getcode',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/Getcode/Getcode'),
      // component: Getcode,
      meta: {
        title: '紫金保险'
      }
    },
    {
      path: '/LoadingUrl',
      name: 'LoadingUrl',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/LoadingUrl/LoadingUrl'),
      // component: LoadingUrl,
      meta: {
        title: '紫金保险'
      }
    },
    {
      path: '/queryPay',
      name: 'queryPay',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/queryPay/queryPay'),
      // component: queryPay
    },
    {
      path: '/credentialsPolicy',
      name: 'credentialsPolicy',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/InsurancePolicy/credentialsPolicy'),
      // component: credentialsPolicy
    },
    {
      path: '/searchPolicy',
      name: 'searchPolicy',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/InsurancePolicy/searchPolicy'),
      // component: searchPolicy
    },
    {
      path: '/face',
      name: 'Face',
      // component: Face,
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/Face/Face'),
      props: (route) => ({
        callbackUrl: route.query.callbackUrl,
        transNo: route.query.transNo
      }),
      meta: {
        title: '刷脸确认'
      }
    },
    {
      path: '/vehicleDetail', //大同选择产品
      name: 'vehicleDetail',
      component: () => import( /* webpackChunkName: "group-DT" */ '@/pages/vehicle/vehicleDetail'),
      // component:vehicleDetail,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/network', //大同选择产品
      name: 'network',
      component: () => import( /* webpackChunkName: "group-DT" */ '@/pages/vehicle/network'),
      // component:vehicleDetail,
      meta: {
        title: '错误'
      }
    },
    {
      path: '/payMent', //大同选择产品
      name: 'payMent',
      component: () => import( /* webpackChunkName: "group-DT1" */ '@/pages/vehicle/payMent'),
      // component:payMent
    },
    {
      path: '/scanPay', //大同选择产品
      name: 'scanPay',
      component: () => import( /* webpackChunkName: "group-DT1" */ '@/pages/vehicle/scanPay'),
      // component:scanPay
    },
    {
      path: '/vehicleTerms', //大同选择产品
      name: 'vehicleTerms',
      component: () => import( /* webpackChunkName: "group-DT1" */ '@/pages/vehicle/vehicleTerms'),
      // component:vehicleTerms
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/vehiclePayStatus', //大同选择产品
      name: 'vehiclePayStatus',
      component: () => import( /* webpackChunkName: "group-DT1" */ '@/pages/vehicle/vehiclePayStatus'),
      // component:vehiclePayStatus
      // component:vehiclePayStatus
    },
    {
      path: '/loadingPay', //loading
      name: 'loadingPay',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/LoadingPay/LoadingPay'),
      meta: {
        title: '支付页面'
      }
    },
    {
      path: '/guaranteeLetterPay', //loading
      name: 'guaranteeLetterPay',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/LoadingPay/GuaranteeLetterPay'),
      meta: {
        title: '支付页面'
      }
    },
    {
      path: '/accountLetter', //loading
      name: 'accountLetter',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/LoadingPay/accountLetter'),
      meta: {
        title: '信息查询'
      }
    },
    {
      path: '/cardNOUpload', //loading
      name: 'cardNOUpload',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/upload/CardNOUpload'),
      meta: {
        title: '工行虚拟管家卡号上传'
      }
    },
    {
      path: '/groupPilotPolicy',
      name: 'groupPilotPolicy',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/InsurancePolicy/GroupPilotPolicy'),
      meta: {
        title: '电子凭证下载'
      }
    },
    {
      path: '/queryInfo',
      name: 'QueryInfo',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/QueryInfo/QueryInfo'),
      meta: {
        title: '网销转外呼信息查询'
      }
    },
    {
      path: '/livingPolicy',
      name: 'LivingPolicy',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/InsurancePolicy/LivingPolicy'),
      meta: {
        title: '山东民生保分户电子凭证下载'
      }
    },
    {
      path: '/pay/:amount/:orderNo',
      name: 'Pay',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/Pay/Pay'),
      meta: {
        title: '紫金保险'
      }
    },
    {
      path: '/drugAttribution',
      name: 'DrugAttribution',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/QueryInfo/DrugAttribution'),
      meta: {
        title: '紫金保险'
      }
    },
    {
      path: '/chargeAccount', 
      name: 'ChargeAccount',
      component: () => import( /* webpackChunkName: "group-common" */ '@/pages/QueryInfo/ChargeAccount'),
      meta: {
        title: '紫金保险'
      }
    },
    {
      path: '/CFgongbao',
      name: 'CFgongbao',
      component: () => import( /* webpackChunkName: "group-common"*/ '@/pages/CFgongbao/gongbao'),
      meta: {
        title: '紫金保险'
      }
    },
    {
      path: '/HLgongbao',
      name: 'HLgongbao',
      component: () => import( /* webpackChunkName: "group-common"*/ '@/pages/HLgongbao/gongbao'),
      meta: {
        title: '紫金保险'
      }
    },
    {
      path: '/MeiCanAccess',
      name: 'MeiCanAccess',
      component: () => import( /* webpackChunkName: "group-common"*/ '@/pages/MeiCanAccess/MeiCanAccess'),
      meta: {
        title: '美餐系统'
      }
    },
    {
      path: '/NJTBInsurance', 
      name: 'NJTBInsurance',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/NJTBInsurance/NJTBInsurance'),
      meta:{
        title:'紫金保险'
      }
    },
    {
      path: '/jumpApp', 
      name: 'jumpApp',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/jumpApp/index'),
      meta:{
        title:'跳转app' 
      }
    },
    {
      path: '/successPay', 
      name: 'successPay',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/LoadingPay/successPay'),
      meta:{
        title:'支付成功' 
      }
    },
    {
      path: '/YZgas', 
      name: 'YZgas',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/YZgas/index'),
      meta:{
        title:'扬州中燃' 
      }
    },
    {
      path: '/YZinsuranceList', 
      name: 'YZinsuranceList',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/YZgas/insuranceList'),
      meta:{
        title:'扬州中燃' 
      }
    },
    {
      path: '/YZorderNoList', 
      name: 'YZorderNoList',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/YZgas/orderNoList'),
      meta:{
        title:'扬州中燃' 
      }
    },
    {
      path: '/YZDownloadFile', 
      name: 'YZDownloadFile',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/YZgas/downloadFile'),
      meta:{
        title:'扬州中燃' 
      }
    },
    {
      path: '/jxPolicy', 
      name: 'jxPolicy',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/downloadPolicy/jxPolicy'),
      meta:{
        title:'保单下载' 
      }
    },
    {
      path: '/queryPage', 
      name: 'queryPage',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/SGH/queryPage'),
      meta:{
        title:'保单' 
      }
    },
    {
      path: '/NJQuerySearch', 
      name: 'NJQuerySearch',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/NJPubilc/index'),
      meta:{
        title:'保单' 
      }
    },
    {
      path: '/c56d0e9a7ccec67b4ea131655038d604', 
      name: 'c56d0e9a7ccec67b4ea131655038d604',
      component:() => import(/* webpackChunkName: "group-common" */'@/pages/egs/controlTime'),
      meta:{
        title:'盐城直连支付截止日期运维' 
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js